import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Card, Table, Input } from "antd";
import { usrRole } from "../../utils/dataUtil";
import { req_list_ssp_school_source_item_detail } from "../../api";

class StudentSourceItemModal extends Component {
  state = {
    userLevel: "",
    loading: false,
    item: {},
    items: [],
  };

  static propTypes = {
    item: PropTypes.object.isRequired,
    cluster: PropTypes.string.isRequired,
    collegeCode: PropTypes.string,
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_list_items();
    this.setState({ item: this.props.item });
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_list_items = async () => {
    const { item, cluster } = this.props;
    const { PlanAcademicYear, HighSchoolCode } = item;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ loading: true, userLevel: userLevel });
    const result = await req_list_ssp_school_source_item_detail(
      userCode,
      userLevel,
      PlanAcademicYear,
      HighSchoolCode,
      cluster,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ items: items, loading: false });
    } else {
      const items = [];
      this.setState({ items: items, loading: false });
    }
  };
  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const { collegeCode } = this.props;
    console.log(this.props.item);
    this.columns = [
      {
        title: "來源科班",
        dataIndex: "HighSchoolDepartmentName",
        width: 30,
        render(text, record) {
          return {
            props: {
              style: { background: "#FFFFE0" },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學制",
        dataIndex: "AcademicSystem",
        width: 30,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "學院",
        dataIndex: "CollegeName",
        width: 50,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "系所",
        dataIndex: "TargetDepartmentName",
        width: 50,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "負責人",
        dataIndex: "TwName",
        width: 25,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "招生管道",
        dataIndex: "SourceName",
        width: 25,
        render(text, record) {
          var textColor = "#FFF";
          switch (record.CollegeCode) {
            case "60": //生活科技學院
              textColor = "#789017";
              break;
            case "59": // 管理學院
              textColor = "#0061ae";
              break;
            case "62": // 設計學院
              textColor = "#f08519";
              break;
            case "63": // 藝術學院
              textColor = "#e40082";
              break;
            case "193": // 旅遊學院
              textColor = "#00706a";
              break;
            default:
              break;
          }
          return {
            props: {
              style: {
                color: textColor,
                fontWeight: 900,
                background:
                  record.CollegeCode === collegeCode ? "#FFD700" : "#FFFFFF",
              },
            },
            children: <div>{text}</div>,
          };
        },
      },
      {
        title: "預收員額",
        width: 25,
        render: (item) => {
          const { NumberConfident } = item;
          return (
            <>
              <Input
                placeholder="人數"
                style={{
                  width: 100,
                  margin: "0 5px",
                  color: "green",
                  fontWeight: 900,
                }}
                value={NumberConfident}
                onChange={(event) =>
                  this.setState({ searchValue: event.target.value })
                }
                disabled={true}
              />
            </>
          );
        },
      },
      {
        title: "規劃員額",
        width: 25,
        render: (item) => {
          const { NumberOfPeople } = item;
          return (
            <>
              <Input
                placeholder="人數"
                style={{
                  width: 100,
                  margin: "0 5px",
                  color: "blue",
                  fontWeight: 900,
                }}
                value={NumberOfPeople}
                onChange={(event) =>
                  this.setState({ searchValue: event.target.value })
                }
                disabled={true}
              />
            </>
          );
        },
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items } = this.state;
    const { HighSchoolCode, HighSchoolTwName, CountyCity } = this.props.item;
    return (
      <Card>
        <form>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="form-group">
                <label>所在縣市</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="CountyCity"
                  id="CountyCity"
                  defaultValue={CountyCity}
                  readOnly={true}
                />
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>學校代號</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="HighSchoolCode"
                  id="HighSchoolCode"
                  defaultValue={HighSchoolCode}
                  readOnly={true}
                />
                <div></div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="form-group">
                <label>學校名稱</label>
                <input
                  type="text"
                  className="form-control text-primary"
                  name="HighSchoolCode"
                  id="HighSchoolCode"
                  style={{ backgroundColor: "LightYellow" }}
                  defaultValue={HighSchoolTwName}
                  readOnly={true}
                />
              </div>
            </div>
          </div>
        </form>
        <Table
          key={items[0]}
          dataSource={items}
          columns={this.columns}
          loading={loading}
          scroll={{ y: 480, x: 800 }}
          pagination={false}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(StudentSourceItemModal);
